import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import WarehouseLocation from "./WarehouseLocation";
import GridConfig from "./GridConfig";
import { Header } from './Header';
import { Footer } from './Footer';

export default class WarehouseLocations extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            warehouseId: props.WarehouseId,
            controllerName: 'warehouselocation',
            data: null,
            loading: true,
            configName: 'warehouselocations_grid',
            moduleName: 'جایگاه های انبار',
            systemModuleId: 5,
            moduleAccessStatus: 1,
            menuId: 19
        };
        this.state.filters = {
            warehouseId: this.state.warehouseId
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            this.state.moduleAccessStatus = data.status;

            this.refreshData();
        });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <WarehouseLocation WarehouseId={this.state.warehouseId} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <WarehouseLocation WarehouseId={this.state.warehouseId} Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "عنوان", show: true },
                { field: "parentTitle", caption: "والد", show: true },
                { field: "location", caption: "موقعیت", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });
            if (f.field == 'parentTitle' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'location' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: "", filter: false, flex: 1, headerName: "عملیات", cellRenderer: (props) => {
                return <div className="item-actions">
                    <a className="item-delete-btn" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                        <i className="mir-trash text-danger"></i>
                    </a>
                    <a className="item-edit-btn" onClick={e => this.onEdit(props.data.id)} title="ویرایش">
                        <i className="mir-pen-edit text-blue-ff"></i>
                    </a>
                </div>
            }
        });
        return t;
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">جایگاه های انبار</h4>
                        </div>
                        <div className="modal-body">
                            <div className="card card-bordered card-stretch">
                                <div className="card-inner-group">
                                    <div className="card-inner p-0">
                                        {this.getToolBar(false, {
                                            add: true,
                                            print: false,
                                            pdf: false,
                                            excell: false,
                                            remove: false,
                                            otherFilters: null,
                                            config: false
                                        })}
                                        {this.renderAgGrid({
                                            columnDefs: this.getColumns()
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>برگشت</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm(),
                this.renderPopupComponent(),
            ];

        return contents;
    }
}